import { useTranslation } from 'next-i18next'

import { Carousel, CarouselContent, CarouselItem } from '@src/ds/blocks/ds-carousel'
import { SubCollection } from '@src/pages/[...slug]/components/collection/domains/Collection'

import MobileSubCollectionChip from './sub-collection-chip-mobile'

const SUBCOLLECTION_FILTER_ARIA_LABEL = 'subcollection_filter_aria_label'

interface MobileSubCollectionCarouselProps {
  subCollections: SubCollection[]
  isSelected: (subCollection: SubCollection) => boolean
  onChipClick: (subCollection: SubCollection) => void
  getLabel: (subCollection: SubCollection) => string
}

export default function MobileSubCollectionCarousel({
  subCollections,
  isSelected,
  onChipClick,
  getLabel,
}: MobileSubCollectionCarouselProps) {
  const { t } = useTranslation('common')

  return (
    <Carousel
      aria-label={t(SUBCOLLECTION_FILTER_ARIA_LABEL)}
      opts={{ align: 'start', containScroll: 'keepSnaps', dragFree: true }}
      css={{ width: 'full' }}
    >
      {/* Vertical padding/negative-margin gives pill focus rings 8px of paint room past the
          viewport's clip without moving the row (supersedes the old 2px shadow allowance). */}
      <CarouselContent
        css={{ gap: 'space-8', paddingX: 'space-16' }}
        viewportCss={{ paddingY: 'space-8', marginY: '-space-8' }}
      >
        {subCollections.map(sc => (
          <CarouselItem key={sc.id} css={{ flex: '0 0 auto' }}>
            <MobileSubCollectionChip
              label={getLabel(sc)}
              selected={isSelected(sc)}
              href={sc.slug ? sc.slug : undefined}
              onClick={() => {
                onChipClick(sc)
              }}
            />
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  )
}
